(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("DatoCmsPlugin", [], factory);
	else if(typeof exports === 'object')
		exports["DatoCmsPlugin"] = factory();
	else
		root["DatoCmsPlugin"] = factory();
})(window, function() {
return 